module.exports = __webpack_public_path__ + "static/media/androidLogo.361b99df.svg";